/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#3778C2';

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'stretch',
		minHeight: 40,
	},

	cell: {
		fontSize: 8,
		padding: 5,
		borderRightWidth: 1,
		borderRightColor: borderColor,
		justifyContent: 'center',
		display: 'flex',
	},

	id: {
		width: '8%',
		textAlign: 'center',
		borderLeftWidth: 1,
		borderLeftColor: borderColor,
	},

	name: {
		width: '20%',
		textAlign: 'left',
	},

	datetimeFrom: {
		width: '18%',
		textAlign: 'center',
	},

	datetimeTo: {
		width: '18%',
		textAlign: 'center',
	},

	latestSchedule: {
		width: '14%',
		textAlign: 'center',
	},

	userName: {
		width: '22%',
		textAlign: 'left',
	},

	endborder: {
		borderBottomColor: borderColor,
		borderBottomWidth: 1,
		width: '100%',
	},
});

const InvoiceTableRow = (props) => {
	const rows = props.data?.map((item, index) => (
		<View key={index} wrap={false}>
			<View style={styles.row}>
				
				<Text style={[styles.cell, styles.id]}>
					{item?.id ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.name]}>
					{item?.name ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.datetimeFrom]}>
					{item?.datetimeFrom ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.datetimeTo]}>
					{item?.datetimeTo ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.latestSchedule]}>
					{item?.latestSchedule ?? 'N/A'}
				</Text>

				<Text style={[styles.cell, styles.userName]}>
					{item?.userName ?? 'N/A'}
				</Text>

			</View>

			<View style={styles.endborder} />
		</View>
	));

	return <>{rows}</>;
};

export default InvoiceTableRow;